import * as actionTypes from '../actions/actionsTypes';
import { updateObject } from '../../utils/common';

const initialState = {
  showLoader: false,
};

const setLoaderLayOver = (state, action) => {
  return updateObject(state, {
    showLoader: action.data,
  });
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETLOADERLAYOVER:
      return setLoaderLayOver(state, action);
    default:
      return state;
  }
};

export default reducer;
